export const BREAKPOINT_SMALL_HANDHELD = '320px';
export const BREAKPOINT_HANDHELD = '960px';
export const BREAKPOINT_TABLET = '1240px';
